import { Points } from '@/types';

const ITERATE_BY = 2;

export const convertPointsToOutputPoints = (points: Array<number>): Points => {
  const output = [];

  for (let i = 0; i < points.length; i += ITERATE_BY) {
    output.push({ x: points[i], y: points[i + 1] });
  }

  return output;
};
